import "./mobileSearch.css";
import React, { useState, useRef, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faTimes, faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { faClock } from "@fortawesome/free-regular-svg-icons";
import useSearchLogic   from "./searchLogic";
import { SEARCH_OPTIONS } from "../../data/registry";

const MobileSearch = () => {
  const [visible, setVisible] = useState(false);
  const [hiddenOptions, setHiddenOptions] = useState<Set<string>>(new Set());

  const lockBody   = () => { document.body.style.height = "100vh"; document.body.style.overflow = "hidden"; };
  const unlockBody = () => { document.body.style.height = "100%";  document.body.style.overflow = "scroll"; };

  const {
    value, setValue,
    clear, search,
  } = useSearchLogic({
    options: SEARCH_OPTIONS,
    onMobileOpen: () => { setVisible(true); lockBody(); },
    onMobileClose: () => { setVisible(false); unlockBody(); },
  });

  const goBack = () => {
    setVisible(false);
    unlockBody();
  };

  const wrapperRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target as Node)) {
        unlockBody();
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const removeOption = (name: string) => {
    setHiddenOptions((prev) => new Set(prev).add(name));
  };

  return (
    <div className="mobile-search-box" style={{ display: visible ? "block" : "none" }}>
      <div className="mobile-search-cont">
        <div className="mobile-search">
          <div className="mobile-search-value" ref={wrapperRef}>
            <FontAwesomeIcon
              className="searchbar-icon back-icon"
              icon={faArrowLeft}
              onClick={goBack}
            />

            <input
              placeholder=" "
              autoComplete="on"
              className="mobile-search-input"
              value={value}
              onChange={(e) => setValue(e.target.value)}
              onKeyUp={(e) => {
                if (e.key === "Enter") {
                  search();
                  goBack();
                }
              }}
            />

            <FontAwesomeIcon
              className="searchbar-icon mobile-clear-icon"
              icon={faTimes}
              title="Clear"
              onClick={clear}
              style={{ display: value ? "inline-block" : "none" }}
            />
          </div>

          <div className="mobile-search-select">
            <div className="mobile-search-options">
              {SEARCH_OPTIONS.map((o) =>
                hiddenOptions.has(o.name) ? null : (
                  <div key={o.name} className="mobile-search-option">
                    <span>
                      <FontAwesomeIcon className="clock-icon" icon={faClock} />
                      <a href={`/${o.value}`}>{o.name}</a>
                    </span>
                    <FontAwesomeIcon
                      className="delete-icon"
                      icon={faTimes}
                      title="Remove"
                      onClick={() => removeOption(o.name)}
                    />
                  </div>
                )
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileSearch;
